__turbopack_context__.v({
  "button": "DetailsDropdown-module__5qECDW__button",
  "container": "DetailsDropdown-module__5qECDW__container",
  "icon": "DetailsDropdown-module__5qECDW__icon",
  "labelClip": "DetailsDropdown-module__5qECDW__labelClip",
  "labelContainer": "DetailsDropdown-module__5qECDW__labelContainer",
  "popover": "DetailsDropdown-module__5qECDW__popover",
});
